import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

import {
  GRAD_PROGRAM_URL_SEGMENTS,
  INTERNSHIP_URL_SEGMENTS,
  JOB_URL_SEGMENTS,
  ORG_TYPE_URL_SEGMENTS,
  VOLOP_URL_SEGMENTS,
  combinedOrgTypeAndInternshipUrlSegments,
  combinedOrgTypeAndJobUrlSegments,
} from './mainRouteSegments';

export const mainRouteGroup = new AppRouteGroup({ path: '' });

export const mainLocalizedRouteGroup = new AppRouteGroup({
  path: '/:lang',
  params: ['lang'],
});

export const mainHomeRoute = mainLocalizedRouteGroup.route({ path: '' });

// Org

export const mainOrgSegmentedRoutes = ORG_TYPE_URL_SEGMENTS.flatMap(
  (orgTypeUrlSegment) => [
    mainLocalizedRouteGroup.route({
      path: `${orgTypeUrlSegment}/:orgIdDashSlug`,
      params: ['orgIdDashSlug'],
    }),
    mainLocalizedRouteGroup.route({
      path: `amp/${orgTypeUrlSegment}/:orgIdDashSlug`,
      params: ['orgIdDashSlug'],
    }),
  ],
);

export const mainOrgSearchRouteReference = mainLocalizedRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: ['areasOfFocus', 'orgType', 'locale', 'q', 'saved'],
});

// Jobs

export const mainJobSegmentedRoutes = [
  ...JOB_URL_SEGMENTS,
  ...combinedOrgTypeAndJobUrlSegments,
].flatMap((jobUrlSegment) => [
  mainLocalizedRouteGroup.route({
    path: `${jobUrlSegment}/:jobIdDashSlug`,
    params: ['jobIdDashSlug'],
  }),
  mainLocalizedRouteGroup.route({
    path: `amp/${jobUrlSegment}/:jobIdDashSlug`,
    params: ['jobIdDashSlug'],
  }),
]);

export const mainJobsSearchRouteReference = mainLocalizedRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: [
    'areasOfFocus',
    'functions',
    'locationType',
    'professionalLevel',
    'education',
    'jobType',
    'orgType',
    'locale',
    'radius',
    'recency',
    'synonymId',
    'q',
    'saved',
  ],
});

// Internship

export const mainInternshipSegmentedRoutes = [
  ...Object.values(INTERNSHIP_URL_SEGMENTS),
  ...combinedOrgTypeAndInternshipUrlSegments,
].flatMap((internshipUrlSegment) => [
  mainLocalizedRouteGroup.route({
    path: `${internshipUrlSegment}/:internshipIdDashSlug`,
    params: ['internshipIdDashSlug'],
  }),
  mainLocalizedRouteGroup.route({
    path: `amp/${internshipUrlSegment}/:internshipIdDashSlug`,
    params: ['internshipIdDashSlug'],
  }),
]);

export const mainInternshipsSearchRouteReference =
  mainLocalizedRouteGroup.route({
    path: ':segment',
    params: ['segment'],
    searchParams: [
      'areasOfFocus',
      'functions',
      'locationType',
      'jobType',
      'orgType',
      'locale',
      'radius',
      'recency',
      'payment',
      'q',
      'saved',
      'synonymId',
    ],
  });

// Volop

export const mainVolopSegmentedRoutes = VOLOP_URL_SEGMENTS.flatMap(
  (volopUrlSegment) => [
    mainLocalizedRouteGroup.route({
      path: `${volopUrlSegment}/:volopIdDashSlug`,
      params: ['volopIdDashSlug'],
    }),
    mainLocalizedRouteGroup.route({
      path: `amp/${volopUrlSegment}/:volopIdDashSlug`,
      params: ['volopIdDashSlug'],
    }),
  ],
);

export const mainVolopsSearchRouteReference = mainLocalizedRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: [
    'areasOfFocus',
    'functions',
    'locationType',
    'locale',
    'radius',
    'recency',
    'actionType',
    'source',
    'startsLT',
    'endsGT',
    'q',
    'saved',
  ],
});

// Grad Program

export const mainGradProgramSegmentedRoutes = GRAD_PROGRAM_URL_SEGMENTS.flatMap(
  (gradProgramUrlSegment) => [
    mainLocalizedRouteGroup.route({
      path: `${gradProgramUrlSegment}/:programIdDashSlug`,
      params: ['programIdDashSlug'],
    }),
    mainLocalizedRouteGroup.route({
      path: `amp/${gradProgramUrlSegment}/:programIdDashSlug`,
      params: ['programIdDashSlug'],
    }),
  ],
);

export const mainGradProgramSearchRouteReference =
  mainLocalizedRouteGroup.route({
    path: ':segment',
    params: ['segment'],
    searchParams: ['q', 'isPublicSchool', 'areasOfStudy', 'saved'],
  });

// Everything Search

export const mainEverythingSearchRouteReference = mainLocalizedRouteGroup.route(
  {
    path: ':segment',
    params: ['segment'],
    searchParams: ['q', 'saved'],
  },
);

// Post a listing

export const mainPostAListingRoute = mainRouteGroup.route({
  path: 'post-a-listing',
  searchParams: [
    'listingType', // JOB | INTERNSHIP | VOLOP
  ],
});

export const mainCreateJobRoute = mainRouteGroup.route({
  path: 'jobs/create',
});

export const mainCreateInternshipRoute = mainRouteGroup.route({
  path: 'internships/create',
});

// Nonprofit Salary Explorer

export const mainSalariesRouteGroup = new AppRouteGroup({
  path: '/nonprofit-salary-explorer',
});

export const mainSalarySurveyRoute = mainSalariesRouteGroup.route({
  path: 'survey',
});

export const mainSalarySurveyFaqRoute = mainSalariesRouteGroup.route({
  path: 'faq',
});

export const mainSalarySurveyLearnMoreRoute = mainSalariesRouteGroup.route({
  path: 'learn-more',
});

export const mainExploreSalaryRoute = mainSalariesRouteGroup.route({
  path: 'explore',
});

// Idealist Profile

export const mainViewUserProfileRoute = mainRouteGroup.route({
  path: 'i/:username',
  params: ['username'],
});
